import ModuleWrapper from './ModuleWrapper.client';
import {useLoadScript} from '@shopify/hydrogen';
import {useEffect} from 'react';
import {SanityModuleOkendo} from '../../types';

export type WindowWithOkendo = Window & {
  okeWidgetApi: {
    initWidget: (id: string, isAsync: boolean) => void;
    initAllWidgets: () => void;
  };
};

type OkendoProps = {
  storefrontProductId?: string;
  heading?: string;
};

const Okendo = ({storefrontProductId, heading}: OkendoProps) => {
  const scriptStatus = useLoadScript(
    'https://d3hw6dc1ow8pp2.cloudfront.net/reviews-widget-plus/js/okendo-reviews.js?shop=goodnature-global.myshopify.com',
  );

  const windowWithOkendo: WindowWithOkendo | null =
    typeof window !== 'undefined'
      ? (window as unknown as WindowWithOkendo)
      : null;

  useEffect(() => {
    if (windowWithOkendo && windowWithOkendo.okeWidgetApi) {
      windowWithOkendo.okeWidgetApi.initAllWidgets();
    }
  }, [scriptStatus]);

  if (scriptStatus === 'loading' || scriptStatus === 'error') {
    return <></>;
  }

  let reviewsProductId: null | string = null;

  if (storefrontProductId) {
    reviewsProductId = `shopify-${storefrontProductId?.split('-').at(-1)}`;
  }

  return (
    <div className="px-gutter pt-20 pb-25" id="reviews">
      {heading && (
        <h2 className="richH1 pb-6 text-center font-bold md:pb-20">
          {heading}
        </h2>
      )}
      <div
        id="oke-reviewsWidget"
        data-oke-widget
        data-oke-reviews-product-id={reviewsProductId}
      ></div>
    </div>
  );
};

type OkendoModuleProps = {
  storefrontProductId?: string;
  module: SanityModuleOkendo;
};

export default function OkendoModule({
  storefrontProductId,
  module,
}: OkendoModuleProps) {
  return (
    <ModuleWrapper className="px-gutter">
      <Okendo
        storefrontProductId={storefrontProductId}
        heading={module?.heading}
      />
    </ModuleWrapper>
  );
}
